const stockChart = (env) => {
  am5.ready(function() {
    am5.addLicense("AM5S354995300");

    // Create root element
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/getting-started/#Root_element
    var root = am5.Root.new("nnnchart");


    // Set themes
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    // Create a stock chart
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/charts/stock-chart/#Instantiating_the_chart
    var stockChart = root.container.children.push(am5stock.StockChart.new(root, {}));


    // Set global number format
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/concepts/formatters/formatting-numbers/
    root.numberFormatter.set("numberFormat", "#,###.00");


    // Create a main stock panel (chart)
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/charts/stock-chart/#Adding_panels
    var mainPanel = stockChart.panels.push(am5stock.StockPanel.new(root, {
      wheelY: "zoomX",
      panX: true,
      panY: true,
      layout: root.verticalLayout
    }));


    // Create value axis
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    var valueAxis = mainPanel.yAxes.push(am5xy.ValueAxis.new(root, {
      renderer: am5xy.AxisRendererY.new(root, {
        pan: "zoom"
      }),
      extraMin: 0.5, // adds some space for for main series
      extraMax: 0.1, // adds some space for for main series
      tooltip: am5.Tooltip.new(root, {}),
      numberFormat: "#,###.00",
      extraTooltipPrecision: 2,
      maxZoomLevel: 2,
    }));

    var dateAxis = mainPanel.xAxes.push(am5xy.GaplessDateAxis.new(root, {
      //maxDeviation: 1,
      baseInterval: {
        timeUnit: "day",
        count: 1
      },
      renderer: am5xy.AxisRendererX.new(root, {}),
      tooltip: am5.Tooltip.new(root, {}),
    }));


    // Add series
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    var valueSeries = mainPanel.series.push(am5xy.CandlestickSeries.new(root, {
      name: "NNN",
      clustered: true,
      valueXField: "date",
      valueYField: "close",
      highValueYField: "high",
      lowValueYField: "low",
      openValueYField: "open",
      calculateAggregates: true,
      minDistance: 10,
      xAxis: dateAxis,
      yAxis: valueAxis,
      legendValueText: "Open: [bold]{openValueY}[/] High: [bold]{highValueY}[/] Low: [bold]{lowValueY}[/] Close: [bold]{valueY}[/]",
      legendRangeValueText: "",
      fill: am5.color(0x428bca),
      stroke: am5.color(0x428bca),
    }));


    // Set main value series
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/charts/stock-chart/#Setting_main_series
    stockChart.set("stockSeries", valueSeries);


    // Add a stock legend
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/charts/stock-chart/stock-legend/
    var valueLegend = mainPanel.plotContainer.children.push(am5stock.StockLegend.new(root, {
      stockChart: stockChart
    }));


    // Create volume axis
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    var volumeAxisRenderer = am5xy.AxisRendererY.new(root, {
      inside: true
    });

    // volumeAxisRenderer.labels.template.set("forceHidden", true);
    // volumeAxisRenderer.grid.template.set("forceHidden", true);

    var volumeValueAxis = mainPanel.yAxes.push(am5xy.ValueAxis.new(root, {
      numberFormat: "#.#a",
      height: am5.percent(20),
      y: am5.percent(100),
      centerY: am5.percent(100),
      renderer: volumeAxisRenderer
    }));

    // Add series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    var volumeSeries = mainPanel.series.push(am5xy.ColumnSeries.new(root, {
      name: "Volume",
      clustered: false,
      valueXField: "date",
      valueYField: "volume",
      xAxis: dateAxis,
      yAxis: volumeValueAxis,
      legendValueText: "[bold]{valueY.formatNumber('#,###.0a')}[/]"
    }));

    volumeSeries.columns.template.setAll({
      strokeOpacity: 0,
      fillOpacity: 0.5
    });

    // color columns by stock rules
    // volumeSeries.columns.template.adapters.add("fill", function(fill, target) {
    //   var dataItem = target.dataItem;
    //   if (dataItem) {
    //     return stockChart.getVolumeColor(dataItem);
    //   }
    //   return fill;
    // })


    // Set main series
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/charts/stock-chart/#Setting_main_series
    stockChart.set("volumeSeries", volumeSeries);
    valueLegend.data.setAll([valueSeries, volumeSeries]);


    // Add cursor(s)
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    mainPanel.set("cursor", am5xy.XYCursor.new(root, {
      yAxis: valueAxis,
      xAxis: dateAxis,
      snapToSeries: [valueSeries],
      snapToSeriesBy: "y!"
    }));


    // Add scrollbar
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/
    var scrollbar = mainPanel.set("scrollbarX", am5xy.XYChartScrollbar.new(root, {
      orientation: "horizontal",
      height: 50
    }));
    stockChart.toolsContainer.children.push(scrollbar);

    var sbDateAxis = scrollbar.chart.xAxes.push(am5xy.GaplessDateAxis.new(root, {
      baseInterval: {
        timeUnit: "day",
        count: 1
      },
      renderer: am5xy.AxisRendererX.new(root, {})
    }));

    var sbValueAxis = scrollbar.chart.yAxes.push(am5xy.ValueAxis.new(root, {
      renderer: am5xy.AxisRendererY.new(root, {})
    }));

    var sbSeries = scrollbar.chart.series.push(am5xy.LineSeries.new(root, {
      valueYField: "close",
      valueXField: "date",
      xAxis: sbDateAxis,
      yAxis: sbValueAxis
    }));

    sbSeries.fills.template.setAll({
      visible: true,
      fillOpacity: 0.3
    });

    var indicatorControl = am5stock.IndicatorControl.new(root, {
      stockChart: stockChart,
      legend: valueLegend
    });



    // Set up series type switcher
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/charts/stock/toolbar/series-type-control/
    var seriesSwitcher = am5stock.SeriesTypeControl.new(root, {
      stockChart: stockChart
    });

    seriesSwitcher.events.on("selected", function(ev) {
      setSeriesType(ev.item.id);
    });

    function getNewSettings(series) {
      var newSettings = [];
      am5.array.each(["name", "valueYField", "highValueYField", "lowValueYField", "openValueYField", "valueXField", "xAxis", "yAxis", "legendValueText", "stroke", "fill"], function(setting) {
        newSettings[setting] = series.get(setting);
      });
      return newSettings;
    }

    function setSeriesType(seriesType) {
      // Get current series and its settings
      var currentSeries = stockChart.get("stockSeries");
      var newSettings = getNewSettings(currentSeries);

      // Remove previous series
      var data = currentSeries.data.values;
      mainPanel.series.removeValue(currentSeries);

      // Create new series
      var series;
      switch (seriesType) {
        case "line":
          series = mainPanel.series.push(am5xy.LineSeries.new(root, newSettings));
          break;
        case "candlestick":
        case "procandlestick":
          newSettings.clustered = false;
          series = mainPanel.series.push(am5xy.CandlestickSeries.new(root, newSettings));
          if (seriesType == "procandlestick") {
            series.columns.template.get("themeTags").push("pro");
          }
          break;
        case "ohlc":
          newSettings.clustered = false;
          series = mainPanel.series.push(am5xy.OHLCSeries.new(root, newSettings));
          break;
      }

      // Set new series as stockSeries
      if (series) {
        valueLegend.data.removeValue(currentSeries);
        series.data.setAll(data);
        stockChart.set("stockSeries", series);
        var cursor = mainPanel.get("cursor");
        if (cursor) {
          cursor.set("snapToSeries", [series]);
        }
        valueLegend.data.insertIndex(0, series);
      }
    }

    const periodSelector = am5stock.PeriodSelector.new(root, {
          stockChart: stockChart,
          periods: [
            { timeUnit: "week", count: 1, name: "1W" },
            { timeUnit: "month", count: 1, name: "1M" },
            { timeUnit: "month", count: 3, name: "3M" },
            { timeUnit: "year", count: 1, name: "1Y" },
            { timeUnit: "year", count: 2, name: "2Y" },
            { timeUnit: "year", count: 3, name: "3Y" },
            { timeUnit: "ytd", name: "YTD" },
          ],
        });

    const fetchedDailyBars = {};
    // Stock toolbar
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/charts/stock/toolbar/
    var toolbar = am5stock.StockToolbar.new(root, {
      container: document.getElementById("nnnchartcontrols"),
      stockChart: stockChart,
      controls: [
        indicatorControl,
        am5stock.DateRangeSelector.new(root, {
          stockChart: stockChart
        }),
        periodSelector,
        seriesSwitcher,
      ]
    });

    //  periodSelector.selectPeriod({ timeUnit: "month", count: 1});
    valueSeries.events.once("datavalidated", function() {
      periodSelector.selectPeriod({ timeUnit: "month", count: 1 });
    });
    // var data = [{
    // 		date: 1664755200000,
    // 		close: 39.83,
    // 		open: 40.36,
    // 		low: 39.41,
    // 		high: 40.69,
    // 		volume: 1196956
    // 	},
    // 	{
    // 		date: 1664496000000,
    // 		close: 39.86,
    // 		open: 39.34,
    // 		low: 39.11,
    // 		high: 40.105,
    // 		volume: 1575000
    // 	},
    // 	{
    // 		date: 1664409600000,
    // 		close: 39.09,
    // 		open: 40.85,
    // 		low: 38.91,
    // 		high: 40.905,
    // 		volume: 1169658
    // 	},
    // 	{
    // 		date: 1664323200000,
    // 		close: 41.33,
    // 		open: 40.81,
    // 		low: 40.41,
    // 		high: 41.59,
    // 		volume: 1275511
    // 	},
    // 	{
    // 		date: 1664236800000,
    // 		close: 40.39,
    // 		open: 41.16,
    // 		low: 40.39,
    // 		high: 41.26,
    // 		volume: 1198331
    // 	},
    // ];

    var tooltip = am5.Tooltip.new(root, {
      getStrokeFromSprite: false,
      getFillFromSprite: false
    });

    tooltip.get("background").setAll({
      strokeOpacity: 1,
      stroke: am5.color(0x000000)
    });


    function makeEvent(date, letter, color, description) {
      var dataItem = dateAxis.createAxisRange(dateAxis.makeDataItem({
        value: date
      }))
      var grid = dataItem.get("grid");
      if (grid) {
        grid.setAll({
          visible: true,
          strokeOpacity: 0.2,
          strokeDasharray: [3, 3]
        })
      }

      var bullet = am5.Container.new(root, {
        y: -100
      });

      var circle = bullet.children.push(am5.Circle.new(root, {
        radius: 10,
        stroke: color,
        fill: am5.color(0xffffff),
        tooltipText: description,
        tooltip: tooltip,
        tooltipY: 0
      }));

      var label = bullet.children.push(am5.Label.new(root, {
        text: letter,
        centerX: am5.p50,
        centerY: am5.p50
      }));

      dataItem.set("bullet", am5xy.AxisBullet.new(root, {
        location: 0,
        sprite: bullet
      }));
    }

    async function fetchDailyBars(startDate, endDate) {
      // Check if data for the requested period is already available
      const existingData = chartData.filter(
        (bar) => new Date(bar.date) >= startDate && new Date(bar.date) <= endDate
      );

      // If all data for the requested period is available, return it
      if (existingData.length === Math.abs(endDate - startDate) / (1000 * 60 * 60 * 24) + 1) {
        return existingData;
      }

      // If not available, fetch the data from the API
      const apiUrl = `https://investors-api.nnnreit.com/nnndailybar/date-range?start=${startDate.toISOString().slice(0, 10)}&end=${endDate.toISOString().slice(0, 10)}`;
      const response = await fetch(apiUrl);
      const newData = await response.json();

      // Merge the fetched data with the existing data and sort by date
      const mergedData = [...chartData, ...newData].sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );

      // Remove duplicates if any
      const finalData = mergedData.filter(
        (bar, index, self) => index === self.findIndex((t) => t.date === bar.date)
      );

      // Update the global chart data array
      chartData = finalData;

      return finalData;
    }

    function getDateForPeriodAgo(date, period) {
      const newDate = new Date(date);
      switch (period.timeUnit) {
        case "1w":
          newDate.setDate(newDate.getDate() - 7 * period.count);
          break;
        case "1m":
          newDate.setMonth(newDate.getMonth() - period.count);
          break;
        case "3m":
          newDate.setMonth(newDate.getMonth() - 3 * period.count);
          break;
        case "1y":
          newDate.setFullYear(newDate.getFullYear() - period.count);
          break;
        case "ytd":
          newDate.setMonth(0);
          newDate.setDate(1);
          break;
        default:
          console.error("Invalid period");
      }
      return newDate;
    }

    const currentDate = new Date().toISOString().slice(0, 10);

    function loadData() {
      axios.get([`https://investors-api.nnnreit.com/nnndailybar/date-range?start=2012-01-01&end=${currentDate}`])
      .then((response) => response.data)
        .then((data) => {
            // console.log(data);
            const processedData = data.map((item) => ({
              date: new Date(`${item.date}T00:00:00`).getTime(),
              open: item.open,
              high: item.high,
              low: item.low,
              close: item.close,
              volume: item.volume,
            })).reverse();
            //console.log("file: stock-chart-test.php:413 ~ processedData ~ processedData:", processedData)
            valueSeries.data.setAll(processedData);
            volumeSeries.data.setAll(processedData);
            sbSeries.data.setAll(processedData);
        });
    }
    loadData();
  }); // end am5.ready()
};